export let MaintenanceRoutes = {
    "/maintenance": {
        "name": "maintenance",
        "type": "frontend",
        "component": 'maintenance',
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("./maintenance.module.js");
                }
            }
        ]
    },
};